import { render, staticRenderFns } from "./AgentTransfer.vue?vue&type=template&id=3d8764c8&scoped=true&"
import script from "./AgentTransfer.vue?vue&type=script&lang=js&"
export * from "./AgentTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8764c8",
  null
  
)

export default component.exports